module.exports = __webpack_public_path__ + "static/media/brown-plus.c0ac9427.svg";